import { useEffect, useState } from "react";

const VARIANTS = {
  success: { accent: "bg-emerald-500", text: "text-emerald-600", light: "bg-emerald-50" },
  error:   { accent: "bg-rose-500",    text: "text-rose-600",    light: "bg-rose-50"    },
  info:    { accent: "bg-indigo-500",  text: "text-indigo-600",  light: "bg-indigo-50"  },
};

const Toast = ({ alert, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (alert) requestAnimationFrame(() => setVisible(true));
    else setVisible(false);
  }, [alert]);

  if (!alert) return null;

  const type = alert.type === "success" ? "success" : alert.type === "error" ? "error" : "info";
  const v = VARIANTS[type];

  return (
    <div className="fixed top-6 inset-x-0 z-[9999] flex justify-center px-4 pointer-events-none">
      <div
        dir="rtl"
        style={{
          transform: visible ? "translateY(0)" : "translateY(10px)",
          opacity: visible ? 1 : 0,
          transition: "transform 260ms ease, opacity 220ms ease",
          boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
        }}
        className={`pointer-events-auto flex items-center gap-3 ${v.light} rounded-xl px-4 py-3 max-w-sm w-full`}
      >
        <div className={`w-1 h-8 rounded-full ${v.accent} shrink-0`} />
        <p className={`flex-1 text-sm font-medium ${v.text}`}>{alert.message}</p>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors text-lg leading-none">×</button>
      </div>
    </div>
  );
};

export default Toast;